import CustomLayout from "./wrapPageElement"
require("katex/dist/katex.min.css")

export const wrapPageElement = CustomLayout
